<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de cierres de caja</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            @click="realizarCierre"
            type="button"
            class="btn-success btn--bigger"
          >
            <i class="fa fa-window-close"></i
            ><span>Realizar cierre de caja</span>
          </button>
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="cuadreEfectivo" class="btn-primary">
            <i class="fa fa-file-excel-o"></i><span>Cuadre de Efectivo</span>
          </button>
          <button type="button" @click="cuadreRecaudacion" class="btn-secondary">
            <i class="fa fa-file-excel-o"></i><span>Cuadre de Recaudación</span>
          </button>
          <button type="button" @click="cierreEntreFechas" class="btn-bus300">
            <i class="fa fa-file-excel-o"></i><span>Cierres entre fechas</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
        <div class="card__title">
            <h5>Filtros de la consulta</h5>
        </div>
        <div class="card__content">
            <div class="row">
                <div class="col-xs-12 col-md-4">
                    <div class="form-field select">
                        <div class="select-field">
                            <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                <option value="H">Hoy</option>
                                <option value="A">Ayer</option>
                                <option value="P">Personalizado</option>
                            </select>
                            <label for="tipo_fecha">Tipo de fecha</label>
                        </div>
                    </div>
                </div>
                <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                    <div class="form-field">
                        <div class="datepicker-field">
                            <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                no-label
                                only-date
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                            />
                            <label>Desde</label>
                        </div>
                    </div>
                </div>
                <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                    <div class="form-field">
                        <div class="datepicker-field">
                            <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                no-label
                                only-date
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                            />
                            <label>Hasta</label>
                        </div>
                    </div>
                </div>
                <div v-show="bodegas.length > 1" class="col-xs-12 col-md-4">
                    <div class="form-field select2">
                        <div class="select2-field">
                            <v-select @input="inputBodega" id="bodega_id" v-model="selectedBodega" :options="bodegas" label="descripcion"></v-select>
                            <label for="bodega">Sucursal</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card__title">
            <h5>Resultados de la consulta</h5>
        </div>
      <div class="card__content">
        <k-table
            :filterStatus="false"
            :buscarButton="false"
          :deleteButton="anular_cierres_caja"
          :editButton="false"
          ref="gastos"
          :params="form"
          @exportar="exportar"
          :buttons="[
            {
              event: 'exportar',
              icon: 'fa-file-excel-o',
              class: 'btn-info btn--text'
            }
          ]"
          :path="path"
          @eliminar="anular"
          :columns="[
            {
              display: 'Fecha',
              value: 'fecha_cierre',
            },
            {
              display: 'Sucursal',
              value: 'bodega.descripcion'
            },
            {
              display: 'Oficinista',
              value: 'usuario.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            }
          ]"
        ></k-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    anular_cierres_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      form: {
        tipo_fecha: "H",
        desde: moment(new Date()).format('YYYY-MM-DD'),
        hasta: moment(new Date()).format('YYYY-MM-DD'),
        bodega_id: ''
      },
      path: url + '/cierre-caja',
      selectedBodega: null
    };
  },
  methods: {
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    cierreEntreFechas: function () {
      if (this.selectedBodega != null) {
        let urlApi = `${url}/cierre-caja-fechas${this.serialize(this.form)}`;
        window.open(urlApi, '_blank');
      }
      else 
        swal('Debe seleccionar una bodega.', 'Aviso', 'warning');
    },
    cuadreRecaudacion: function () {
      let urlApi = `${url}/cuadre-recaudacion${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    cuadreEfectivo: function () {
      let urlApi = `${url}/cuadre-efectivo${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    exportar: function(cierre) {
      window.open(url + '/cierre-caja/' + cierre.id, '_blank');
    },
    inputBodega: function () {
        if (this.selectedBodega != null)
            this.form.bodega_id = this.selectedBodega.id;
        else 
            this.form.bodega_id = '';
    },
    realizarCierre: function () {
      window.open(url + "/cierre-caja/create", "_blank");
    },
    consultar: function () {
        this.$refs.gastos.loadRows();
    },
    anular: function (cierre) {
      swal({
          title: "¿Desea anular el cierre de caja?",
          text: "Se requiere confirmación",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Anular",
          cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          axios.post(url + '/cierre-caja/' + cierre.id, {
            _method: 'DELETE'
          }).then(() => {
            swal('El cierre de caja fue anulado exitósamente.', 'Realizado', 'success');
            this.consultar();
          }).catch(({response}) => {
            if (response.status == 409) {
              swal('Solo se puede anular el último cierre.', 'Aviso', 'warning');
            }
            else 
              swal('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    }
  },
  mounted: function () {
    if (this.bodegas.length === 1) {
        this.selectedBodega = this.bodegas[0];
        this.inputBodega();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/administrativo/ConsultaCierresCaja.vue